export default __webpack_public_path__ + "43cbee784f9194c54b2c65a223f89c5d.ttf";